export default require('./ChapterNext').default
